import { Permission, Res } from 'core/api';
import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Command, Electron } from 'pos/common';
import { Message } from 'core/ui-next/modal';

declare global {
	interface CommandType {
		minimizeWindow: () => Promise<Result>
	}
}

Command.register('minimizeWindow', Preconditions.ensure(Permission.Screen_Minimize), async (): Promise<Result> => {
	if (!Electron.isEnabled()) {
		await Message.show(Res.Msg.MSG_ELECTRON_IS_REQUIRED_TO_MINIMIZE_WINDOW());
		return Result.error();
	}

	await Electron.Window.minimize();
	return Result.ok();
});